import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariela G.',
    loc: '📍 Córdoba | Docente de Matemática Primaria',
    quote: 'Compré el PROFEPACK un domingo a la noche. El lunes tenía todo el año de Matemática de primaria organizado por grado. Nunca pensé que un material iba a ser tan completo. Las secuencias están pensadas para que el curso entienda, no solo para cubrir contenido.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Mendoza | Docente de Matemática Primaria y Secundaria',
    quote: 'Empecé con Primaria y a los 3 días compré el Pack Completo. Doy clases en los dos niveles y no podía trabajar con la mitad del sistema. El Banco de Consignas me cambió la vida: ya no pierdo tiempo pensando cómo redactar lo que quiero que hagan.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Buenos Aires | Docente de Matemática',
    quote: 'El Pack de Errores Típicos me salvó el año. Siempre perdía tiempo explicando lo mismo. Con las tarjetas de intervención sé exactamente qué preguntar y cómo destrabar en 3 minutos. Mis colegas me preguntan cómo mantengo el ritmo de clase.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Tucumán | Docente de Matemática Primaria',
    quote: 'Lo que más valoro es que está organizado POR GRADO. No tengo que adivinar qué le corresponde a cada año. Todo ya está pensado, secuenciado y listo. Es como tener un colega experto que ya hizo todo el trabajo previo por mí.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Rosario | Docente de Matemática Secundaria',
    quote: "Como profe de secundaria lo que más me cambió fueron los tomos de funciones y modelización. Mis alumnos de 3° y 4° año por fin entienden para qué sirve lo que hacemos. Ya no tengo que pelearme con la pregunta '¿esto para qué lo aprendemos?'"
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Santa Fe | Docente de Matemática Primaria',
    quote: 'Tenía miedo de que fuera material genérico que no encajara con mi realidad. Pero desde la primera clase noté que estaba pensado para Argentina, para el aula real, para docentes que tienen 30 chicos y poco tiempo. No es teoría: es práctica.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-255">
      <div className="max-w-6xl mx-auto" data-id="element-256">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-257">
          LO QUE DICEN LOS DOCENTES DE MATEMÁTICA QUE YA TIENEN SU{' '}
          <span className="text-brand-accent" data-id="element-258">PROFEPACK:</span>
          <div className="text-xl text-white/70 mt-4 font-medium" data-id="element-259">
            +2.000 docentes de Argentina ya lo usan
          </div>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-260">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-261">
              <div className="flex items-center gap-5 mb-8" data-id="element-262">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-263">
                  {test.initials}
                </div>
                <div data-id="element-264">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 estrellas" data-id="element-265">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-266">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-267">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-268">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}